module.exports = __webpack_public_path__ + "static/media/Mapa-Minas Gerais.399fac85.svg";